import { Flex, Box, Heading, FormLabel } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import { FormikSelectAsyncPaginate, FormikSwitch } from 'components/Formik';
import { fetchPaginatedEmployeeGroup } from 'hooks/employee/useFetchPaginatedEmployeeGroups';
import { getAsyncSelectLoadOptions } from 'utils/helpers';

import { initialFilterFormData } from './schema';
interface IFilterFormProps {
  handleFilterFormSubmit: (values: typeof initialFilterFormData) => void;
}

const FilterForm: React.FC<IFilterFormProps> = ({ handleFilterFormSubmit }) => {
  const { t } = useTranslation(['common', 'whoIsWorking']);

  const groupLoadOptions = (page: number, search: string, jobId: any) => {
    return getAsyncSelectLoadOptions(fetchPaginatedEmployeeGroup, { page, search, jobId: jobId });
  };

  return (
    <Box px="4" py="2" width="340px" minWidth="200px">
      <Heading as="h5" size="md" mb="4">
        Filters
      </Heading>
      <Formik initialValues={initialFilterFormData} onSubmit={handleFilterFormSubmit}>
        {() => (
          <Form autoComplete="off">
            <Flex flexWrap="wrap">
              <Box display="flex" justifyContent="space-between" mb="4" width="100%">
                <FormLabel fontSize="sm">{t('whoIsWorking:showNotClockedInUsers')}</FormLabel>
                <FormikSwitch name="notWorking" />
              </Box>

              <FormikSelectAsyncPaginate
                name="group_ids"
                label={'Filter by group'}
                loadOptions={groupLoadOptions}
                selectProps={{
                  isMulti: true,
                  placeholder: t('common:selectAGroup'),
                  getOptionLabel: (option: any) => option?.name,
                  getOptionValue: (option: any) => option.id,
                }}
              />
            </Flex>
            <Box textAlign="right">
              <Button type="submit" colorScheme="secondary" alignSelf="flex-start" data-testid="filter-button">
                {t('common:filter')}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default FilterForm;
